const videos = {
  slug: 'f/videos',
  getVideo: () => `${videos.slug}`,
  uploadVideo: () => `${videos.slug}`
}

export default videos
